import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Resource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  assignManagerToResource(
    request: Boundaries["assignManagerToResource"]["request"],
  ): void;
}

function useAssignManagerToResource(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAssignManagerToResourceRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAssignManagerToResourceRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAssignManagerToResourceRequestFailure(resource),
    ),
    assignManagerToResource: core.assignManagerToResource,
  };
}

export { useAssignManagerToResource };
